<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
}

</script>

<style lang="scss">

@import '~normalize.css';
@import '~assets/styles/mui.scss';

html {
  height: 100%;
}

body {
  height: 100%;
  background-color: #efeff4;

  &.white {
    background-color: #fff;
  }
}

</style>



// WEBPACK FOOTER //
// App.vue?d501ff7e